/** URL media: upload locali e host legacy -> backend corrente. */
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const DEV_PROXY_TARGET = (process.env.REACT_APP_DEV_PROXY_TARGET || "https://6amico.com").replace(
  /\/$/,
  "",
);
const ORIGIN = BACKEND || (() => {
  if (typeof window === "undefined") return "https://6amico.com";
  const host = (window.location.hostname || "").toLowerCase();
  if (host === "localhost" || host === "127.0.0.1") return window.location.origin;
  return "https://6amico.com";
})();

function devStaticAssetUrl(path) {
  if (process.env.NODE_ENV !== "development" || !DEV_PROXY_TARGET) return null;
  if (!path.startsWith("/hero/") && !path.startsWith("/images/") && !path.startsWith("/img/")) {
    return null;
  }
  return `${DEV_PROXY_TARGET}${path}`;
}

const UPLOAD_PREFIXES = [
  "http://164.92.161.151/api/uploads/",
  "https://164.92.161.151/api/uploads/",
  "https://6amico.com/api/uploads/",
  "http://6amico.com/api/uploads/",
  "https://www.6amico.com/api/uploads/",
  "http://www.6amico.com/api/uploads/",
  "http://127.0.0.1:8080/api/uploads/",
  "http://localhost:8080/api/uploads/",
  "http://127.0.0.1:8001/api/uploads/",
  "http://localhost:8001/api/uploads/",
];

export function resolveMediaUrl(url) {
  if (!url) return url;
  const raw =
    typeof url === "string"
      ? url
      : typeof url === "object"
        ? (url.url || url.src || url.path || url.file || "")
        : "";
  if (typeof raw !== "string") return null;
  const s = raw.trim();
  if (!s) return s;
  const devStatic = devStaticAssetUrl(s);
  if (devStatic) return devStatic;
  if (s.startsWith("/api/uploads/")) {
    return `${ORIGIN}${s}`;
  }
  for (const prefix of UPLOAD_PREFIXES) {
    if (s.startsWith(prefix)) {
      return `${ORIGIN}/api/uploads/${s.slice(prefix.length)}`;
    }
  }
  return s;
}
